module.exports = __webpack_public_path__ + "img/2_166.cf44c603.png";